import RequestPrescreenerReasonForCareController from 'client-portal/controllers/-request/prescreener-reason-for-care';

export default class WidgetPrescreenerReasonForCare extends RequestPrescreenerReasonForCareController {}
